import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type MagentoAccount = {
  id: string;
  label: string;
  baseUrl: string;
  consumerKey: string;
  consumerSecret: string;
  accessToken: string;
  accessTokenSecret: string;
  storeCode?: string;
};

type AccountsState = {
  accounts: MagentoAccount[];
  activeAccountId: string | null;
};

const initialState: AccountsState = {
  accounts: [],
  activeAccountId: null,
};

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    setAccounts(state, action: PayloadAction<AccountsState>) {
      state.accounts = action.payload.accounts;
      state.activeAccountId = action.payload.activeAccountId;
    },
    addAccount(state, action: PayloadAction<MagentoAccount>) {
      state.accounts.push(action.payload);
      state.activeAccountId = action.payload.id;
    },
    updateAccount(state, action: PayloadAction<MagentoAccount>) {
      const index = state.accounts.findIndex((account) => account.id === action.payload.id);
      if (index !== -1) {
        state.accounts[index] = action.payload;
      }
    },
    removeAccount(state, action: PayloadAction<string>) {
      state.accounts = state.accounts.filter((account) => account.id !== action.payload);
      if (state.activeAccountId === action.payload) {
        state.activeAccountId = state.accounts[0]?.id ?? null;
      }
    },
    setActiveAccount(state, action: PayloadAction<string>) {
      state.activeAccountId = action.payload;
    },
    clearAccounts(state) {
      state.accounts = [];
      state.activeAccountId = null;
    },
  },
});

export const {
  setAccounts,
  addAccount,
  updateAccount,
  removeAccount,
  setActiveAccount,
  clearAccounts,
} = accountsSlice.actions;
export default accountsSlice.reducer;
